/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable indent */
import PropTypes from 'prop-types'
import React from 'react'
import { Header } from '../Header'
import { connect } from 'react-redux'
import { AdditionalPreloader } from 'SRC/ui/Preloader'
import { getCurrentSubCategory, getFlattenCategories } from 'src/modules/categories/selectors'
import { Select, MultipleSelect, Checkbox } from 'SRC/ui/FormElements'
import { change, formValueSelector, touch } from 'redux-form'
import { AdsBrandsApi } from 'SRC/modules/ads/brands/api'
import { AdsProductsApi } from 'SRC/modules/ads/products/api'
import { ReduxFormRequired } from 'Core/validators/reduxForm'

export class CompatibilityMultiselect extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = this.initState()
	}

	static getDerivedStateFromProps = (props, state) => {
	  if (props.compatibilityUniversality !== state.isUniversal) {
	    return { isUniversal: props.compatibilityUniversality }
	  }
	  return null
	}

	async componentDidMount () {
		if (this.props.adCompatibilities && this.props.adCompatibilities.length) {
			const compatibilities = this.props.adCompatibilities

			const category = compatibilities[0].category
			const currentSubCategory = this.props.categories.find(cat => cat.id === category)

			if (currentSubCategory) await this.setState({currentSubCategory})

			await	this.loadBrandsToState(category)

			if (compatibilities.length) {
				this.setState({ adCompatibilitiesLoading: true })
				let brands = []
				let products = {}
				let years = {}
				for (const compatibility of compatibilities) {
					if (compatibility.brand) {
						if (!brands.includes(compatibility.brand)) brands.push(compatibility.brand)

						if (!compatibility.product) {
							if (compatibility.years) {
								years[compatibility.brand] = compatibility.years
							}
						}
					}
					if (compatibility.product) {
						if (!products[compatibility.brand]) products[compatibility.brand] = []
						products[compatibility.brand].push(compatibility.product)

						if (compatibility.years) {
							years[compatibility.product] = compatibility.years
						}
					}
				}

				if (brands.length) {
					await this.setState({ checkedBrands: brands })
					await this.loadProductsToState(brands)
				}

				if (Object.keys(products).length) {
					const checkedProducts = Object.values(products).reduce((acc, curr) => {
						acc.push(...curr); return acc
					}, [])
					const productsTransformed = this.getTransformedProducts(checkedProducts)
					await this.setState({ products: productsTransformed })
					await this.setState({ checkedProducts })
				}
				if (Object.keys(years).length) {
					await this.setState({ checkedYears: years })
				}

				this.setState({ adCompatibilitiesLoading: false })
			}
		}
	}

	componentDidUpdate (prevProps) {
	  if (prevProps.category.id !== this.props.category.id) {
	    const resetState = this.initState()
	    this.setState({...resetState, resetCheckedOptions: true})
	  } else {
	    if (this.state.resetCheckedOptions) this.setState({resetCheckedOptions: false})
	  }
	}

	// Get fields

	getCategoryField = () => ({
	  id: 'compatibilityCategory',
	  name: 'compatibilityCategory',
	  label: 'Kategorija',
	  options: this.prepareCategories(),
	  onChange: this.onCategoryChange,
	  isRequired: true,
	  selectClassName: 'ads-add__select',
	  validate: ReduxFormRequired
	})

	getBrandsField = () => ({
	  id: 'compatibilityBrands',
	  name: 'compatibilityBrands',
	  label: `Proizvođač`,
	  options: this.state.brands,
	  onChange: this.onBrandsChange,
		disabled: !this.state.brands.length,
		checked: this.state.checkedBrands,
	  isRequired: true,
	  selectClassName: 'ads-add__select',
	  validate: [ReduxFormRequired, this.brandsLimit(this.state.brandsLimit)]
	})

	getProductsField = () => ({
	  id: 'compatibilityProducts',
	  name: 'compatibilityProducts',
	  label: `Model`,
	  options: this.state.products,
	  onChange: this.onProductsChange,
	  disabled: !this.state.products.length,
	  checked: this.state.checkedProducts,
	  isRequired: true,
	  selectClassName: 'ads-add__select',
	  validate: [ReduxFormRequired, this.productsPerBrandLimit(this.state.productsPerBrandLimit)]
	})

	getYearsField = () => ({
	  id: 'compatibilityYears',
	  name: 'compatibilityYears',
	  options: this.prepareYears(),
		onChange: this.onYearsChange,
	  isRequired: true,
	  selectClassName: 'ads-add__select',
	  validate: ReduxFormRequired
	})

	getCommonYearsField = () => ({
	  id: 'commonCompatibilityYears',
		name: 'commonCompatibilityYears',
		label: 'Zajednička godišta',
	  options: this.prepareYears(),
		onChange: this.onCommonYearsChange,
	  isRequired: false,
	  selectClassName: 'ads-add__select'
	})

	// Event listeners

	onCategoryChange = e => {
	  const category = Number(e.target.value)
		this.setState({ checkedBrands: [], checkedProducts: [] })
	  this.handleCategoryChange(category)
	}

	handleCategoryChange = async (category, update = false) => {
		if (update) this.props.change(this.props.formName, this.getCategoryField().name, category)
		await this.props.change(this.props.formName, this.getBrandsField().name, [])
	  await this.props.change(this.props.formName, this.getProductsField().name, {})
	  await this.props.change(this.props.formName, this.getYearsField().name, {})

	  const currentSubCategory = this.props.categories.find(cat => cat.id === category)

	  if (currentSubCategory) this.setState({currentSubCategory})

	  this.loadBrandsToState(category)
	}

	onBrandsChange = async brands => {
	  await this.props.touch(this.props.formName, this.getBrandsField().name)
	  let brandsTransformed = []

	  if (this.state.brandsLimit && (brands.length >= this.state.brandsLimit)) {
	    brandsTransformed = this.state.brands.map(brand => {
	      if (brands.includes(brand.id.toString())) return {...brand}
	      else return {...brand, isDisabled: true}
	    })
	  } else {
	    brandsTransformed = this.state.brands.map(brand => ({
	      ...brand,
	      isDisabled: false
	    }))
	  }

		this.setState({brands: brandsTransformed})

	  await this.props.change(this.props.formName, this.getBrandsField().name, brands)

		const compatibilityProducts = this.props.compatibilityProducts
	  if (compatibilityProducts) {
	    const updatedProducts = brands.reduce((acc, curr) => {
	      if (compatibilityProducts[curr] && compatibilityProducts[curr].length) {
					acc[curr] = compatibilityProducts[curr]
				}
	      return acc
			}, {})

	    await this.props.change(this.props.formName, this.getProductsField().name, updatedProducts)

	    const checkedProducts = Object.values(updatedProducts).reduce((acc, curr) => {
	      acc.push(...curr)
	      return acc
	    }, [])

	    this.setState({checkedProducts})
	  }

	  this.loadProductsToState(brands)
	}

	onProductsChange = async products => {
	  await this.props.touch(this.props.formName, this.getProductsField().name)

	  let selectedProductsByBrands = this.getSelectedProductsByBrands(products) || {}
	  let productsTransformed = this.getTransformedProducts(products) || []

	  if (productsTransformed.length) {
	    this.setState({products: productsTransformed})
	  }
	  await this.props.change(this.props.formName, this.getProductsField().name, selectedProductsByBrands)
	}

	getSelectedProductsByBrands = products => {
		let selectedProductsByBrands = {}
		for (let productBrand of this.state.products) {
	    const filteredProducts = productBrand.options
	      .filter(option => products.includes(option.id.toString()))
	      .map(product => product.id)
	    selectedProductsByBrands[productBrand.id] = filteredProducts
		}
		return selectedProductsByBrands
	}

	getTransformedProducts = products => {
		console.log('produkti', products)
		let productsTransformed = []
	  for (let productBrand of this.state.products) {
	    const filteredProducts = productBrand.options
	      .filter(option => products.includes(option.id.toString()))
	      .map(product => product.id)

	    if (this.state.productsPerBrandLimit && (filteredProducts.length >= this.state.productsPerBrandLimit)) {
	      productsTransformed.push({
	        ...productBrand,
	        options: productBrand.options.map(option => ({
	          ...option,
	          isDisabled: !filteredProducts.includes(option.value)
	        }))
	      })
	    } else {
	      productsTransformed.push({
	        ...productBrand,
	        options: productBrand.options.map(option => ({
	          ...option,
	          isDisabled: false
	        }))
	      })
	    }
		}
		return productsTransformed
	}

	onYearsChange = async (years, props) => {
		console.log('onyearschangeprops', props)
		const { compatibilityYears } = this.props
		let value = {}
		if (compatibilityYears) {
			if (props.brand) {
				value = {
					...compatibilityYears,
					[props.brand]: years
				}
			}

			if (props.product) {
				value = {
					...compatibilityYears,
					[props.product]: years
				}
			}
		} else {
			if (props.brand) {
				value = { [props.brand]: years }
			}

			if (props.product) {
				value = { [props.product]: years }
			}
		}
	  await this.props.touch(this.props.formName, this.getYearsField().name)
		await this.props.change(this.props.formName, this.getYearsField().name, value)
	}

	onCommonYearsChange = async (years) => {
		await this.props.change(this.props.formName, this.getCommonYearsField().name, years)
	}

	confirmCommonYearsForProducts = async e => {
		e.preventDefault()
		const { commonCompatibilityYears, compatibilityProducts } = this.props
		await this.setState({ showCommonYears: false })
		if (commonCompatibilityYears && commonCompatibilityYears.length) {
			if (compatibilityProducts && Object.keys(compatibilityProducts).length) {
				const newCompatibilityYears = {}
				for (let brandProduct of Object.keys(compatibilityProducts)) {
					for (let product of compatibilityProducts[brandProduct]) {
						newCompatibilityYears[product] = commonCompatibilityYears
					}
				}
				await this.setState({ checkedYears: newCompatibilityYears })
				await this.props.change(this.props.formName, this.getYearsField().name, newCompatibilityYears)
			}
		}
		await this.props.change(this.props.formName, this.getCommonYearsField().name, [])
		await this.setState({ showCommonYears: true })
	}

	confirmCommonYearsForBrands = async e => {
		e.preventDefault()
		const { commonCompatibilityYears, compatibilityBrands } = this.props
		await this.setState({ showCommonYears: false })
		if (commonCompatibilityYears && commonCompatibilityYears.length) {
			if (compatibilityBrands && compatibilityBrands.length) {
				const newCompatibilityYears = {}
				for (let brand of compatibilityBrands) {
					newCompatibilityYears[brand] = commonCompatibilityYears
				}
				await this.setState({ checkedYears: newCompatibilityYears })
				await this.props.change(this.props.formName, this.getYearsField().name, newCompatibilityYears)
			}
		}
		await this.props.change(this.props.formName, this.getCommonYearsField().name, [])
		await this.setState({ showCommonYears: true })
	}

	// Updating state methods

	initState = () => {
	  const { category } = this.props
	  return {
	    isBrandsLoading: false,
	    brands: [],
	    brandsLimit: category.compatibilityBrandsQuantity,
	    isProductsLoading: false,
	    products: [],
	    productsPerBrandLimit: category.compatibilityModelsQuantity,
	    universalityEnabled: category.compatibilityUniversality,
	    isUniversal: false,
			currentSubCategory: null,
			checkedBrands: [],
			checkedProducts: [],
			checkedYears: {},
			showCommonYears: true,
			resetCheckedOptions: false,
			adCompatibilitiesLoading: false
	  }
	}

	loadBrandsToState = async category => {
	  this.setState({
	    isBrandsLoading: true,
	    brands: [],
	    products: []
	  })

	  const brandsApi = new AdsBrandsApi()
	  const brands = await brandsApi.getBrandsByCategory(category)

	  this.setState({
	    isBrandsLoading: false,
	    brands: this.prepareBrands(brands)
	  })
	}

	loadProductsToState = async brands => {
	  this.setState({
	    ...this.state,
	    products: [],
	    isProductsLoading: true
	  })

	  const productsApi = new AdsProductsApi()
	  let products = []
	  for (const brand of brands) {
	    const productsByBrand = await productsApi.fetchProductByBrandAndCategory({
	      brand: Number(brand),
	      category: Number(this.props.selectedCategory)
	    })
	    products.push(...productsByBrand)
		}

		const productsPrepared = this.prepareProducts(products, this.state.brands.filter(brand =>
			brands.includes(brand.id.toString()) || brands.includes(brand.id)))

	  this.setState({
	    ...this.state,
	    products: productsPrepared,
	    isProductsLoading: false
	  })
	}

	// Prepare methods
	prepareCategories = () =>
		this.props.category && this.props.category.compatibilityCategories
		? this.props.category.compatibilityCategories.map(cat => ({
	      id: cat.id,
	      label: cat.title,
	      value: cat.id,
	      isGrouped: false
	    })) : null

	prepareBrands = (brands = []) => brands.map(brand => ({
	  id: brand.id,
	  label: brand.name,
	  value: brand.id,
	  isGrouped: false
	}))

	prepareProducts = (products = [], brands = []) => brands.map(brand => {
	  return {
	    id: brand.id,
	    label: brand.label,
	    isDisabled: false,
	    value: brand.id,
	    isGrouped: true,
	    options: products.filter(product => Number(product.brand) === Number(brand.id))
	      .map(product => ({
	        id: product.id,
	        label: product.model,
	        value: product.id
	      }))
	  }
	})

	prepareYears = () => {
	  const yearNow = new Date().getFullYear()
	  const years = []

	  for (let i = 1900; i <= yearNow; i++) years.unshift(i)

	  return years.map(year => ({
	    id: year,
	    label: year.toString(),
	    value: year,
	    isGrouped: false
	  }))
	}

	brandsLimit = limit => brands => {
		return limit && brands && brands.length > limit
			? `Brands limit: ${limit}` : undefined
	}

	productsPerBrandLimit = limit => productsByBrand => {
	  for (const brandKey in productsByBrand) {
	    if (Array.isArray(productsByBrand[brandKey])) {
	      if (this.state.productsPerBrandLimit && (
	        productsByBrand[brandKey].length > this.state.productsPerBrandLimit
	      )) return `Products limit: ${limit}`
	    }
	  }
	  return undefined
	}

	getBrandLabel = brandId => {
		let label = ''
		const brand = this.state.brands.find(brand => brand.id === Number(brandId))
		if (brand) {
			label = brand.label
		}

		return label
	}

	getProductLabel = (brandId, productId) => {
		let label = ''
		const brandProducts = this.state.products.find(bp => bp.id === Number(brandId))
		if (brandProducts) {
			const productOption = brandProducts.options.find(productOption => productOption.id === productId)
			if (productOption) label = productOption.label
		}

		return label
	}

	onUniversalityChecked = () => {
	  this.setState({checkedBrands: [], checkedProducts: [], checkedYears: []})
	  this.props.change(this.props.formName, this.getBrandsField().name, [])
	  this.props.change(this.props.formName, this.getProductsField().name, {})
	  this.props.change(this.props.formName, this.getYearsField().name, [])
	}

	renderYearsForProducts = () => {
		const { compatibilityProducts } = this.props

		if (compatibilityProducts && Object.keys(compatibilityProducts).length) {
			const yearsField = this.getYearsField()
			const commonYearsField = this.getCommonYearsField()
			return <div className='products-years'>
  			<div className='products-years-first-column'>
    			<Header title='Godišta za modele:' />
    			{this.state.showCommonYears ? <MultipleSelect key='common-years' {...commonYearsField} /> : null}
    			<button onClick={this.confirmCommonYearsForProducts}>Potvrdi</button>
  			</div>
  			{this.state.showCommonYears ? <div className='products-years-second-column'>
    			{Object.keys(compatibilityProducts).map(brandId => compatibilityProducts[brandId]
					.map(productId => <MultipleSelect key={`years-${productId}`} resetOptions={this.state.resetCheckedOptions}
  					{...yearsField} checked={this.state.checkedYears[productId] || []} product={productId}
  					label={`Godišta za ${this.getProductLabel(brandId, productId)}`} />
					))}
  			</div> : null}
			</div>
		}
	}

	renderYearsForBrands = () => {
		const { compatibilityBrands } = this.props

		if (compatibilityBrands && compatibilityBrands.length) {
			const yearsField = this.getYearsField()
			const commonYearsField = this.getCommonYearsField()
			return <div className='products-years'>
  			<div className='products-years-first-column'>
    			<Header title='Godišta za proizvođače:' />
    			{this.state.showCommonYears ? <MultipleSelect key='common-years' {...commonYearsField} /> : null}
    			<button onClick={this.confirmCommonYearsForBrands}>Potvrdi</button>
  			</div>
  			{this.state.showCommonYears ? <div className='products-years-second-column'>
    			{compatibilityBrands.map(brandId => <MultipleSelect key={`years-${brandId}`}
      			resetOptions={this.state.resetCheckedOptions} {...yearsField}
      			checked={this.state.checkedYears[brandId] || []} brand={brandId}
      			label={`Godišta za ${this.getBrandLabel(brandId)}`} />
					)}
  			</div> : null}
			</div>
		}
	}

	renderYears = () => {
		const { category } = this.props
		const { currentSubCategory } = this.state

		const showYear = category && category.compatibilityYears
		if (showYear && currentSubCategory) {
			if (currentSubCategory.requiredAdOptions === 'BrandModel') {
				return this.renderYearsForProducts()
			} else {
				return this.renderYearsForBrands()
			}
		}
		return null
	}

	render () {
		const { category } = this.props
	  const categoryField = this.getCategoryField()
		let brandsField, productsField, shouldRenderProducts, shouldRenderUniversality

		if (category && category.compatibilityUniversality) shouldRenderUniversality = true

	  if (!this.state.isUniversal) {
	    brandsField = this.getBrandsField()

	    const currentSubCategory = this.state.currentSubCategory
	    if (currentSubCategory) {
	      if (currentSubCategory.requiredAdOptions === 'BrandModel') {
	        shouldRenderProducts = true
	        productsField = this.getProductsField()
	      }
	    }
	  }
		return !this.state.adCompatibilitiesLoading ? <React.Fragment>
  		<Header title='Izaberite za koju kategoriju i proizvođača odgovara predmet koji prodajete' />
  		<Select {...categoryField} />
  		{!this.state.isUniversal ? <React.Fragment>
    		{!this.state.isBrandsLoading ? <MultipleSelect key='brands' {...brandsField}
      		resetOptions={this.state.resetCheckedOptions} /> : null}
    		{!this.state.isProductsLoading && shouldRenderProducts ? <MultipleSelect key='products'
      		{...productsField} resetOptions={this.state.resetCheckedOptions} /> : null}
  		</React.Fragment> : null}
  		<br />
  		{shouldRenderUniversality ? <Checkbox id='compatibilityUniversality' label='Ovaj predmet je univerzalan'
    		name='compatibilityUniversality' onInput={this.onUniversalityChecked} /> : null}
  		{this.renderYears()}
		</React.Fragment> : <AdditionalPreloader />
	}
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.formName)
  return {
    category: getCurrentSubCategory(state),
    categories: getFlattenCategories(state),
    selectedCategory: selector(state, 'compatibilityCategory'),
    compatibilityUniversality: selector(state, 'compatibilityUniversality'),
    compatibilityProducts: selector(state, 'compatibilityProducts'),
    compatibilityBrands: selector(state, 'compatibilityBrands'),
    compatibilityYears: selector(state, 'compatibilityYears'),
    commonCompatibilityYears: selector(state, 'commonCompatibilityYears')
  }
}

CompatibilityMultiselect.propTypes = {
  category: PropTypes.shape({
		id: PropTypes.number,
		compatibilityCategories: PropTypes.array,
		compatibilityUniversality: PropTypes.bool,
		compatibilityBrandsQuantity: PropTypes.number,
		compatibilityModelsQuantity: PropTypes.number,
		compatibilityYears: PropTypes.bool
  }),
	categories: PropTypes.array.isRequired,
	adCompatibilities: PropTypes.array,
  formName: PropTypes.oneOf(['addAd', 'editAd']),
  selectedCategory: PropTypes.string,
	compatibilityUniversality: PropTypes.bool,
	compatibilityBrands: PropTypes.array,
	compatibilityProducts: PropTypes.object,
	compatibilityYears: PropTypes.object,
	commonCompatibilityYears: PropTypes.array,
	change: PropTypes.func,
	touch: PropTypes.func
}

export default connect(mapStateToProps, ({ change, touch }))(CompatibilityMultiselect)
